import React from 'react';

import DevicesSettingsSectionNew from '../../../DevicesSettingsSection/DevicesSettingsSectionNew';

const SwitchSettingButton = ({useSettingHook, onNavigate, ...props}) => {
    const {currentValue, icon, title} = useSettingHook();

    if (!title || !icon) return null;

    return (
        <DevicesSettingsSectionNew.Button
            {...props}
            title={title}
            subTitle={currentValue?.icon?.title}
            icon={currentValue?.icon}
            onClick={onNavigate}
        />
    );
};

export default SwitchSettingButton;
